module.exports = __webpack_public_path__ + "img/cup-dark.08b1877d.svg";